import {z} from 'zod';

import {slugify} from '../../functions/slugify';

export const slimUserSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    thumbnail: z.string(),
  })
  .transform((user) => ({
    ...user,
    slug: slugify(user.name),
  }));
